import { motion } from "framer-motion";
import { Type } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { FormData } from "../types";

interface NamesStepProps {
  formData: FormData;
  onChange: (field: keyof FormData, value: string) => void;
}

const NamesStep = ({ formData, onChange }: NamesStepProps) => {
  const getPlaceholder = () => {
    switch (formData.nameCount) {
      case "one":
        return "Maria";
      case "two":
        return "Luis and Sofia";
      case "three_plus":
        return "Ava, Noah, and Liam";
      case "group":
        return "The Rodriguez Family";
      default:
        return "Enter the name(s)";
    }
  };

  return (
    <motion.div
      key="names"
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      className="space-y-6"
    >
      <div className="text-center mb-8">
        <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
          <Type className="w-8 h-8 text-primary" />
        </div>
        <h2 className="font-heading text-2xl font-bold text-foreground mb-2">
          Names to Include in the Song
        </h2>
        <p className="text-muted-foreground">
          Enter the names exactly as you want them included.
        </p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="names">Names *</Label>
        <Input
          id="names"
          placeholder={getPlaceholder()}
          value={formData.names}
          onChange={(e) => onChange("names", e.target.value)}
          className="text-lg py-6"
        />
        <p className="text-sm text-muted-foreground">
          ⚠️ Please double check spelling. Names will be used exactly as entered.
        </p>
      </div>
    </motion.div>
  );
};

export default NamesStep;
